import { render, staticRenderFns } from "./ancientBooks.vue?vue&type=template&id=5c82703a&scoped=true&"
import script from "./ancientBooks.vue?vue&type=script&lang=js&"
export * from "./ancientBooks.vue?vue&type=script&lang=js&"
import style0 from "./ancientBooks.vue?vue&type=style&index=0&id=5c82703a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82703a",
  null
  
)

export default component.exports